import { Directive, HostBinding, Input } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Directive({
  selector: '[formFieldHintState]'
})
export class FormFieldHintStateDirective {
  @Input('formFieldHintState') control: AbstractControl;

  @HostBinding('hidden')
  get hidden() {
    if (!this.control) return false
    const ctlr = this.control
    if (!ctlr.hasError('required')) return true
    return ctlr.value !== null && ctlr.value !== '' && ctlr.value !== undefined
  }
}